module.exports = __webpack_public_path__ + "media/images/xml_file-7cc2b7be1d669a5cfdf65f26723b617f.png";